import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useLang } from "../../contexts/LanguageContext";

export default function Navbar() {
  const location = useLocation();
  const { user } = useAuth();
  const { t, lang, toggleLang } = useLang();
  const isActive = (path) => location.pathname === path;

  return (
    <nav
      data-testid="main-navbar"
      className="fixed inset-x-0 top-0 z-50 flex items-center justify-between px-[5.5%] h-[60px] border-b"
      style={{ background: "rgba(255,255,255,0.92)", backdropFilter: "blur(14px)", borderColor: "var(--kyra-li)" }}
    >
      <Link to="/" data-testid="navbar-logo" className="no-underline flex items-center gap-2">
        <span style={{ fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 900, fontSize: 22, letterSpacing: 2, color: "var(--kyra-tx)" }}>KYRA</span>
      </Link>
      <div className="flex items-center gap-5">
        {[
          { to: "/solutions", label: t("nav.solution") },
          { to: "/cas-reels", label: t("nav.casReels"), hide: "sm" },
          { to: "/engagements", label: t("nav.engagements"), hide: "sm" },
          { to: user ? "/dashboard" : "/login", label: user ? t("nav.dashboard") : t("nav.connexion"), hide: "sm" },
        ].map((link) => (
          <Link
            key={link.to}
            to={link.to}
            data-testid={`nav-${link.to.split("/").pop()}`}
            className={`text-[13px] no-underline transition-colors ${link.hide ? "hidden sm:inline" : ""}`}
            style={{ color: isActive(link.to) ? "var(--kyra-gr)" : "var(--kyra-mu)", fontWeight: isActive(link.to) ? 500 : 400 }}
          >
            {link.label}
          </Link>
        ))}
        <button
          data-testid="lang-toggle"
          onClick={toggleLang}
          className="text-[11px] font-medium tracking-wider uppercase px-2.5 py-1 rounded-md cursor-pointer transition-all"
          style={{ background: "transparent", border: "1px solid var(--kyra-li)", color: "var(--kyra-mu)" }}
          title={lang === "fr" ? "Switch to English" : "Passer en francais"}
        >
          {lang === "fr" ? "EN" : "FR"}
        </button>
        <Link
          to="/contact"
          data-testid="nav-contact"
          className="text-[13px] font-medium no-underline text-white px-5 py-2 rounded-md transition-colors"
          style={{ background: "var(--kyra-gr)" }}
        >
          {t("nav.contact")}
        </Link>
      </div>
    </nav>
  );
}
